<template lang="pug">
  v-container
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      )
        h2 You currently have {{ admins }} {{ admins > 1 ? 'admins' : 'admin' }}.
    v-row(justify="center")
      v-col(
        cols="12"
        md="11"
      ) 
        v-card(flat)
          v-card-text
            v-row.mx-0
              v-col(
                cols="12"
                sm="4"
                md="3"
              )
                v-avatar(style="height: inherit; width: inherit;")
                  v-img(
                    :src="imageDefault"
                    aspect-ratio="1"
                  )
              v-col(
                cols="12"
                sm="8"
                md="9"
              )
                p.mt-5.mb-0.font-24 Carl Aruta
                p.mb-5.accent--text.font-16 Super Admin
                v-btn(color="primary").plain
                  v-icon(left) mdi-plus 
                  span Add Admin
                v-col(cols="6").px-0
                  v-text-field(
                    label="Search admins"
                    append-icon="mdi-magnify"
                    single-line
                    outlined
                    v-model="keyword"
                    @input="find(keyword)"
                  )
            v-row.mx-0.mt-4
              v-divider
            v-row.mx-0
              v-simple-table(fixed-header)
                thead
                  tr
                    th(@click="sort('name', sortName)").text-left.hand-pointer 
                      span Admin Name
                      v-icon(v-if="typeof sortName !== 'undefined'") {{ chevron(sortName) }}
                    th.text-left Email
                    th(@click="sort('date', sortDate)").text-left.hand-pointer 
                      span Date
                      v-icon(v-if="typeof sortDate !== 'undefined'") {{ chevron(sortDate) }}
                tbody
                  tr(
                    v-for="(admin, i) in adminFilteredList" 
                    :key="i"
                    :style=" i%2 === 0 ? '' : 'background: #0000000d'"
                  )
                    td 
                      v-avatar(
                        size="40"
                        left
                      )
                        img(:src="admin.picURL") 
                      span.pl-4 {{ admin.name }}
                    td {{ admin.email }}
                    td {{ formatDate(admin.date) }} 
</template>

<script>
import datefnsFormat from 'date-fns/format';
import imageDefault from '@/assets/avatar-placeholder.png';

export default {
  data: () => ({
    keyword: '',
    admins: 0,
    adminFilteredList: [{}],
    sortName: undefined,
    sortDate: undefined,
    imageDefault
  }),
  mounted () {
    this.admins = this.$store.state.organization.organization.admins.length;
    this.adminFilteredList = this.$store.state.organization.organization.admins;
  },
  methods: {
    formatDate (date) {
      return date && datefnsFormat(date, 'M/dd/yyyy');
    },
    async find (keyword) {
      try {
        this.adminFilteredList = await this.$store.dispatch('organization/findAdmins', { keyword });
      } catch (e) {
        console.log(e);
      }
    },
    sort (key, sort = true) {
      function compare (a, b) {
        if (a[key] > b[key]) return sort ? 1 : -1;
        if (b[key] > a[key]) return sort ? -1 : 1;

        return 0;
      }

      this.adminFilteredList.sort(compare);

      switch (key) {
        case 'name':
          this.sortName = !sort;
          this.sortEmail = undefined;
          this.sortDate = undefined;
          break;
        case 'date':
          this.sortDate = !sort;
          this.sortEmail = undefined;
          this.sortName = undefined;
          break;
      }
    },
    chevron (sort) {
      return sort ? 'mdi-chevron-down' : 'mdi-chevron-up';
    }
  }
};
</script>

<style scoped>
.handpointer {
  cursor: pointer;
}
</style>